export default [
  {
    path: '/main/manufacturers',
    meta: {
      tag: 'list_manufacturer',
      name: 'Fabricantes',
      breadcrumb: 'Fabricantes'
    },
    component: () => import(/* webpackChunkName: "manufacturers-list" */ '@/views/main/settings/stock-registers/manufacturer/Index.vue'),
    children: [
      {
        path: '',
        name: 'listmanufacturers',
        meta: {
          tag: 'list_manufacturer',
          menu: 'settings',
          name: 'Fabricantes'
        },
        component: () => import(/* webpackChunkName: "manufacturers-list" */ '@/views/main/settings/stock-registers/manufacturer/List.vue')
      },
      {
        path: '/main/manufacturer/add',
        name: 'addmanufacturer',
        meta: {
          tag: 'add_manufacturer',
          menu: 'settings',
          name: 'Adicionar | Fabricante',
          breadcrumb: 'Adicionar Fabricante'
        },
        component: () => import(/* webpackChunkName: "manufacturer-add" */ '@/views/main/settings/stock-registers/manufacturer/Add.vue')
      },
      {
        path: '/main/manufacturer/:id',
        name: 'editmanufacturer',
        meta: {
          tag: 'edit_manufacturer',
          menu: 'settings',
          name: 'Editar | Fabricante',
          breadcrumb: 'Editar Fabricante'
        },
        component: () => import(/* webpackChunkName: "manufacturer-edit" */ '@/views/main/settings/stock-registers/manufacturer/Edit.vue')
      }
    ]
  },
]
